export interface NumberOptionControlProps {
  valueLabel: string
  onDecrement: () => void
  onIncrement: () => void
  squareButtonClassName: string
  valuePillClassName: string
  registerDecrementButton?: (el: HTMLButtonElement | null) => void
  registerIncrementButton?: (el: HTMLButtonElement | null) => void
}

export function NumberOptionControl({
  valueLabel,
  onDecrement,
  onIncrement,
  squareButtonClassName,
  valuePillClassName,
  registerDecrementButton,
  registerIncrementButton,
}: NumberOptionControlProps) {
  return (
    <>
      <button ref={registerDecrementButton} tabIndex={-1} className={squareButtonClassName} onClick={onDecrement}>
        -
      </button>
      <div className={valuePillClassName}>{valueLabel}</div>
      <button ref={registerIncrementButton} tabIndex={-1} className={squareButtonClassName} onClick={onIncrement}>
        +
      </button>
    </>
  )
}

